import { fetchJSON } from '@bonnet/next/fetch';

import { pageNames } from '@atc/bonnet-paths';

const { BUILD_PRICE } = pageNames;

export default function addBuildAndPricePageData() {

    return async (ctx) => {

        const sourceQuery = ctx.data.requestOptions.optionalRequestLSC.query;

        const searchQuery = { ...sourceQuery };

        if (sourceQuery?.ownerId) {
            searchQuery.ownerIdToBoost = sourceQuery.ownerId;
        }

        if (sourceQuery?.zip) {
            searchQuery.zip = Array.isArray(sourceQuery.zip) ? sourceQuery.zip[0] : sourceQuery.zip;
        }

        const listingsRequestOptions = {
            ...ctx.data.requestOptions.optionalRequestLSC,
            query: searchQuery,
        };

        // extract vdp listing id from referrer if it exists
        const referrer = ctx?.query?.referrer;
        const params = referrer ? new URLSearchParams(decodeURIComponent(referrer).split('?')?.[1]) : '';
        const listingId = params && params.get('listingId');

        /*
         * preorder will return top dealers based on zip
         *
         * query
         * zip: required
         * ownerIdToBoost: will return that owner first
         */
        const preorderDealers = await fetchJSON('/rest/lsc/customorder/dealers', {
            ...listingsRequestOptions,
            circuitBreaker: {
                ...listingsRequestOptions.circuitBreaker,
                id: 'customorder_dealer',
            },
        });

        let vdpListing = null;

        /*
         * If B&P page is loaded server side, the inventory store will be need to be repopulated to allow nav to vdp
         */
        if (typeof window === 'undefined' && ctx.pageName === BUILD_PRICE && listingId) {
            const vdpRequestOptions = {
                ...ctx.data.requestOptions.optionalRequest,
                query: {
                    listingId,
                },
            };

            // TODO add LSC fetch option
            vdpListing = await fetchJSON('/rest/lsc/listing/', {
                ...vdpRequestOptions,
                circuitBreaker: {
                    ...vdpRequestOptions.circuitBreaker,
                    id: 'vdp_listing',
                },
            });
        }

        Object.assign(ctx.data, {
            preorder: preorderDealers,
            vdpListing,
        });
    };
}
